import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Route, withRouter, Switch } from 'react-router'
import {
  RouteEnum as MeuBairroRouteEnum,
  ComunidadeIuppProvider,
  Home,
  StoreDetails,
  SaleDetails,
  SaleSearch,
  StoreSearch
} from '@comunidade-iupp/portal'

import '@comunidade-iupp/portal/assets/theme/default/main.css'

import { fetchParticipant } from '../../Participant/ducks'

const categories = {
  pharmacy: {
    id: process.env.REACT_APP_COMUNIDADE_IUPP_PHARMACY_CATEGORY,
    name: 'Farmácias'
  },
  laboratory: {
    id: process.env.REACT_APP_COMUNIDADE_IUPP_PHARMACY_LABORATORY,
    name: 'Laboratórios'
  },
  welfare: {
    id: process.env.REACT_APP_COMUNIDADE_IUPP_PHARMACY_WELFARE,
    name: 'Bem-estar'
  }
}

const MeuBairroRouter = ({ access_token: accessToken }) => (
  <Switch>
    <ComunidadeIuppProvider
      promoApiBaseUrl={process.env.REACT_APP_COMUNIDADE_PROMO_API_BASE_URL}
      promoSubscriptionKey={
        process.env.REACT_APP_COMUNIDADE_PROMO_API_SUBSCRIPTION_KEY
      }
      comunidadeIuppApiBaseUrl={process.env.REACT_APP_COMUNIDADE_API_BASE_URL}
      comunidadeIuppSubscriptionKey={
        process.env.REACT_APP_COMUNIDADE_API_SUBSCRIPTION_KEY
      }
      googleMapsApiKey={process.env.REACT_APP_COMUNIDADE_IUPP_GOOGLE_MAPS_KEY}
      companyManagementUrl={process.env.REACT_APP_COMUNIDADE_COMPANY_MANAGEMENT}
      fechParticipant={fetchParticipant}
      accessToken={accessToken}
      categories={categories}
    >
      <Route path={MeuBairroRouteEnum.Root} exact component={Home} />
      <Route path={MeuBairroRouteEnum.StoreDetail} component={StoreDetails} />
      <Route path={MeuBairroRouteEnum.SaleDetail} component={SaleDetails} />
      <Route path={MeuBairroRouteEnum.SaleSearch} component={SaleSearch} />
      <Route path={MeuBairroRouteEnum.StoreSearch} component={StoreSearch} />
    </ComunidadeIuppProvider>
  </Switch>
)

MeuBairroRouter.propTypes = {
  access_token: PropTypes.string
}

const mapStateToProps = ({ oidc: { user } }) => ({ ...user })
export default withRouter(connect(mapStateToProps, null)(MeuBairroRouter))



// WEBPACK FOOTER //
// ./src/features/MeuBairro/MeuBairroRouter.js